import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const deleteBankDetail = createAsyncThunk(
  "deleteBankDetail/deleteBankDetail",
  async (payload, thunkAPI) => {
    try {
     
      const response = await api.delete(`bank/${payload.user_id}`, {
        data: payload
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const deleteBankDetailSlice = createSlice({
  name: "deleteBankDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteBankDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBankDetail.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteBankDetail.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deleteBankDetailSlice.reducer;
